export type LanguageType = "ja" | "en";

export type RouteType = {
  path: string;
  element: React.ReactNode;
  requiredAuth?: boolean;
  withoutLayout?: boolean;
  redirect?: string;
  superAdminOnly?: boolean;
  requireAssignment?: boolean;
  requiredAccessRights?: number[];
  redirectWhenPermissionDenied?: string;
  // translation key
  label?: string;
  hideBreadcrumb?: boolean;
};

export enum EAccount {
  CLIENT = "client",
  STAFF = "staff",
  EMPLOYEE = "employee",
  CORPORATION = "corporation",
}

export enum EFileType {
  PDF = "pdf",
  IMAGE = "image",
}

export enum EAccessType {
  EMPTY = "",
  NULL = "null",
  BU = "bu",
  CORP = "corp",
  COM = "com",
  SEARCH = "search",
  KENSAKU_KUN = "kensakukun",
}

export type TBooleanRecord = Record<string | number, boolean>;

export type TNullable<T> = T | null;

export enum EFilterType {
  STAFF = "staff",
  EMPLOYEE = "employee",
  CLIENT = "client",
  CORPORATION = "corporation",
  JOB_LISTING = "job_listing",
}
